export default (base64, mimeType = 'image/jpeg') =>
  `data:${mimeType};base64, ${base64}`;
